import { AREA_REQUEST, CREATE_AREA, GET_AREAS, UPDATE_AREA, DELETE_AREA, AREA_REQUEST_FAILURE, AREA_REQUEST_SUCCESS, GET_AREAS_PAGE } from '../types';

const initialState = {
  areas: [],
  areasPage: [],
  loading: false,
  error: null,
};

const areaReducer = (state = initialState, action) => {
  switch (action.type) {
    case AREA_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_AREAS: {
      return {
        ...state,
        areas: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_AREAS_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        areasPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_AREA:
      return {
        ...state,
        areas: [action.payload, ...state.areas],
        loading: false,
        error: null
      };
    case UPDATE_AREA:
      const areasData = state.areas.slice(0);
      const uIndex = areasData.findIndex((data) => data.id === action.payload.id);
      areasData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        areas: [ ...areasData ],
        loading: false,
        error: null
      };
    case DELETE_AREA:
      const areas = state.areas?.slice(0);
      const index = areas.findIndex((data) => data.id === action.id);
      if (index > -1) {
        areas.splice(index, 1);
      }
      return {
        ...state,
        areas: [...areas],
        loading: false,
        error: null
      }
    case AREA_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case AREA_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default areaReducer;
